import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
	signLoader = false; captchaVal = false; captcha = "";
  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  resolved(res: string) {
		if (res != "") { this.captcha = res; this.captchaVal = true; }
	}

  submitFunc(login: NgForm) {			
		var data = login.value;
		// if (!this.captchaVal) {
		// 	return;
		// }
		this.captcha = "";		
		this.signLoader = true;
		this.conn.postUrl('users/forgotPassword', data).subscribe((res: any) => {
			if (res.status == 1) {
				this.alert.success('Reset Password link sent to your email');
			}else {
				this.alert.error(res.msg);
			}
			login.resetForm();
			this.signLoader = false;
		});		
			
	}

	removeSpace(event: any) {
		if (event.code === 'Space') {
			event.preventDefault();
		}
	}

}
